export const TAB_BAR_HEIGHT = 60;
export const ENABLE_SUPPORT_FORM_V1 = false;
